import type { PlantDowntimeItem } from "../types";

export function parseDowntimeToSeconds(input: string | number): number {
  if (typeof input === "number") {
    return Number.isFinite(input) ? Math.max(0, input) : 0;
  }

  if (!input || typeof input !== "string") return 0;

  const trimmed = input.trim();
  if (!trimmed) return 0;

  const timeParts = trimmed.split(":");
  const dayHourPart = timeParts[0] || "0";
  const dayHourSplit = dayHourPart.split(".");

  const days = dayHourSplit.length > 1 ? parseInt(dayHourSplit[0], 10) || 0 : 0;
  const hours = parseInt(dayHourSplit[dayHourSplit.length - 1], 10) || 0;
  const minutes = timeParts[1] ? parseInt(timeParts[1], 10) || 0 : 0;
  const secondsPart = timeParts[2] || "0";
  const secondsSplit = secondsPart.split(".");
  const seconds = parseInt(secondsSplit[0], 10) || 0;
  const fractionalSeconds = secondsSplit[1]
    ? parseInt(secondsSplit[1].padEnd(2, "0").slice(0, 2), 10) / 100
    : 0;

  return (
    days * 24 * 3600 +
    hours * 3600 +
    minutes * 60 +
    seconds +
    fractionalSeconds
  );
}

export function formatSecondsToDowntime(seconds: number): string {
  const totalSeconds = Math.max(0, Math.floor(seconds));
  if (totalSeconds === 0) return "00:00:00";

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;

  const hoursStr = hours >= 100 ? String(hours) : String(hours).padStart(2, "0");
  return `${hoursStr}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
}

export function parseDowntimeToHours(input: string | number): number {
  return parseDowntimeToSeconds(input) / 3600;
}

export function calculateAverageDowntimeSeconds(
  items: PlantDowntimeItem[],
): number {
  if (items.length === 0) return 0;
  const sum = items.reduce((acc, item) => acc + item.downtimeSeconds, 0);
  return sum / items.length;
}
